export const MEDIA_GT_XS = "(min-width: 600px)";

export const MEDIA_GT_SM = "(min-width: 960px)";

export const MEDIA_GT_MD = "(min-width: 1280px)";
